
import { defineComponent } from 'vue';
import AlbertaHeader from '../components/AlbertaAssets/AlbertaHeader.vue';
import AlbertaFooter from '../components/AlbertaAssets/AlbertaFooter.vue';
import Header from '../components/Header/Header.vue';
import MapLegend from '../components/MapLegend/MapLegend.vue';
import Map from '../components/Map/Map.vue';
import Search from '../components/Search/Search.vue';
import List from '../components/List/List.vue';

export default defineComponent({
    name: 'MainPage',
    components: {
        AlbertaHeader,
        AlbertaFooter,
        Header,
        MapLegend,
        Map,
        Search,
        List
    },
    setup() {}
});
